import { default as access_45deniedwa2i1IIV6nMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/access-denied.vue?macro=true";
import { default as index0gMqcOewdiMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/account/index.vue?macro=true";
import { default as integrationRSK01iOtlTMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/account/integration.vue?macro=true";
import { default as notificationsCSYrNnByLbMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/account/notifications.vue?macro=true";
import { default as print_45agentsvCJo3Nr8L8Meta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/account/print-agents.vue?macro=true";
import { default as products7GkhV0jiB2Meta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/account/products.vue?macro=true";
import { default as requisitesgbta3cQANZMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/account/requisites.vue?macro=true";
import { default as usersPJtdsZ5t86Meta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/account/users.vue?macro=true";
import { default as accountl5CQoFQl1BMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/account.vue?macro=true";
import { default as admin_45analyticshPzwEB2EhxMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/admin-analytics.vue?macro=true";
import { default as _91id_93rCAHjsUk9FMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/admin-organizations/[id].vue?macro=true";
import { default as indexyFSvNMmUsqMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/admin-organizations/index.vue?macro=true";
import { default as admin_45overviewEvSzAdovgRMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/admin-overview.vue?macro=true";
import { default as admin_45panelwZWou2UvyOMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/admin-panel.vue?macro=true";
import { default as admin_45tariffsZa0k06w9PFMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/admin-tariffs.vue?macro=true";
import { default as all_45usersB3TaOBFQ8jMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/all-users.vue?macro=true";
import { default as payment_45result0IPvgacIgYMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/billing/payment-result.vue?macro=true";
import { default as chestny_45znakl1MH0Q7KS9Meta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/chestny-znak.vue?macro=true";
import { default as _91id_93BNygKPhzNVMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/client/details/[id].vue?macro=true";
import { default as indexUderSExJaLMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/client/list/index.vue?macro=true";
import { default as indexUqXYcLvO2aMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/counterparties/index.vue?macro=true";
import { default as designerVJeYRcZCNfMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/designer.vue?macro=true";
import { default as index5GWPvAs6IDMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/document/list/index.vue?macro=true";
import { default as _91slug_934NjLRjKhcAMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/documents/[slug].vue?macro=true";
import { default as indexsLOVaL63cvMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/element-catalog/index.vue?macro=true";
import { default as indexqHtEbes263Meta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/fbs/assembly/index.vue?macro=true";
import { default as supplies9o9GslF2CGMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/fbs/assembly/supplies.vue?macro=true";
import { default as indexAyQ4jpnHekMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/fbs/index.vue?macro=true";
import { default as _91id_93kIMXtOSI25Meta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/fbs/supplies/[id].vue?macro=true";
import { default as indexgUxLAkdHDzMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/fbs/verification/index.vue?macro=true";
import { default as feature_45lockednYFwxf0OENMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/feature-locked.vue?macro=true";
import { default as indexaLy3W3JfhNMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/index.vue?macro=true";
import { default as inviteAH0ZX8KVUSMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/invite.vue?macro=true";
import { default as _91key_93wY3A1hYFi9Meta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/legal/[key].vue?macro=true";
import { default as indexeUJ4xh0kfVMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/legal/index.vue?macro=true";
import { default as logintWMHmBLVXhMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/login.vue?macro=true";
import { default as labelsq9aQmQDivpMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/marking/labels.vue?macro=true";
import { default as offerh1BW0Pvc1HMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/offer.vue?macro=true";
import { default as personalVm9CvgOFmQMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/personal.vue?macro=true";
import { default as indexK3GLGppqVAMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/printing/groups/index.vue?macro=true";
import { default as indexwQZZyN1PLHMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/printing/jobs/index.vue?macro=true";
import { default as indexzWoxo0Q9ZgMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/printing/printer/index.vue?macro=true";
import { default as indexV2aUNBKdoCMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/printing/sessions/index.vue?macro=true";
import { default as _91id_93YctRdDDWgbMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/product/details/[id].vue?macro=true";
import { default as indexXzaJOqSPAFMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/product/list/index.vue?macro=true";
import { default as _91id_93Mvbro1fQKVMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/product/marking/[id].vue?macro=true";
import { default as labelsEsxizUJ20hMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/product/marking/labels.vue?macro=true";
import { default as _91id_93YnfinMMOW3Meta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/production-order/details/[id].vue?macro=true";
import { default as guide76ctu0BL8MMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/production-order/guide.vue?macro=true";
import { default as indextEqHIxIomhMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/production-order/list/index.vue?macro=true";
import { default as registerEludZrAJ7mMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/register.vue?macro=true";
import { default as _91id_93wEayt8uuJBMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/repricer/details/[id].vue?macro=true";
import { default as index1cWBlJtDpMMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/repricer/list/index.vue?macro=true";
import { default as reset_45passwordpQOmNanLiBMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/reset-password.vue?macro=true";
import { default as _91id_93Bl1uSOXBbqMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/scenarios/[id].vue?macro=true";
import { default as index10Ko9QvYrWMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/scenarios/index.vue?macro=true";
import { default as shopsP4s69TuimfMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/shops.vue?macro=true";
import { default as subscriptione9L32hkxLsMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/subscription.vue?macro=true";
import { default as indexAlao6tTthjMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/support-admin/index.vue?macro=true";
import { default as indexzcOq6bApn1Meta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/support/index.vue?macro=true";
import { default as indexYbplYOyJstMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/system-employees/index.vue?macro=true";
import { default as verify_45emailTB4QNELewGMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/verify-email.vue?macro=true";
import { default as indexKz5ot380pFMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/warehouse/cells/index.vue?macro=true";
import { default as _91id_93XShcRrf8PtMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/warehouse/intake/[id].vue?macro=true";
import { default as indexqZrFIWxTSuMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/warehouse/intake/index.vue?macro=true";
import { default as indexyizSDLvUlYMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/warehouse/journal/index.vue?macro=true";
import { default as indexx8tPisRqaAMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/warehouse/settings/index.vue?macro=true";
import { default as _91id_93A3GwYtz5wQMeta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/warehouse/staff/[id].vue?macro=true";
import { default as indexXB5MxDUuY0Meta } from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/warehouse/staff/index.vue?macro=true";
export default [
  {
    name: access_45deniedwa2i1IIV6nMeta?.name ?? "access-denied",
    path: access_45deniedwa2i1IIV6nMeta?.path ?? "/access-denied",
    meta: access_45deniedwa2i1IIV6nMeta || {},
    alias: access_45deniedwa2i1IIV6nMeta?.alias || [],
    redirect: access_45deniedwa2i1IIV6nMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/access-denied.vue").then(m => m.default || m)
  },
  {
    name: accountl5CQoFQl1BMeta?.name ?? undefined,
    path: accountl5CQoFQl1BMeta?.path ?? "/account",
    meta: accountl5CQoFQl1BMeta || {},
    alias: accountl5CQoFQl1BMeta?.alias || [],
    redirect: accountl5CQoFQl1BMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/account.vue").then(m => m.default || m),
    children: [
  {
    name: index0gMqcOewdiMeta?.name ?? "account",
    path: index0gMqcOewdiMeta?.path ?? "",
    meta: index0gMqcOewdiMeta || {},
    alias: index0gMqcOewdiMeta?.alias || [],
    redirect: index0gMqcOewdiMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: integrationRSK01iOtlTMeta?.name ?? "account-integration",
    path: integrationRSK01iOtlTMeta?.path ?? "integration",
    meta: integrationRSK01iOtlTMeta || {},
    alias: integrationRSK01iOtlTMeta?.alias || [],
    redirect: integrationRSK01iOtlTMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/account/integration.vue").then(m => m.default || m)
  },
  {
    name: notificationsCSYrNnByLbMeta?.name ?? "account-notifications",
    path: notificationsCSYrNnByLbMeta?.path ?? "notifications",
    meta: notificationsCSYrNnByLbMeta || {},
    alias: notificationsCSYrNnByLbMeta?.alias || [],
    redirect: notificationsCSYrNnByLbMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/account/notifications.vue").then(m => m.default || m)
  },
  {
    name: print_45agentsvCJo3Nr8L8Meta?.name ?? "account-print-agents",
    path: print_45agentsvCJo3Nr8L8Meta?.path ?? "print-agents",
    meta: print_45agentsvCJo3Nr8L8Meta || {},
    alias: print_45agentsvCJo3Nr8L8Meta?.alias || [],
    redirect: print_45agentsvCJo3Nr8L8Meta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/account/print-agents.vue").then(m => m.default || m)
  },
  {
    name: products7GkhV0jiB2Meta?.name ?? "account-products",
    path: products7GkhV0jiB2Meta?.path ?? "products",
    meta: products7GkhV0jiB2Meta || {},
    alias: products7GkhV0jiB2Meta?.alias || [],
    redirect: products7GkhV0jiB2Meta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/account/products.vue").then(m => m.default || m)
  },
  {
    name: requisitesgbta3cQANZMeta?.name ?? "account-requisites",
    path: requisitesgbta3cQANZMeta?.path ?? "requisites",
    meta: requisitesgbta3cQANZMeta || {},
    alias: requisitesgbta3cQANZMeta?.alias || [],
    redirect: requisitesgbta3cQANZMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/account/requisites.vue").then(m => m.default || m)
  },
  {
    name: usersPJtdsZ5t86Meta?.name ?? "account-users",
    path: usersPJtdsZ5t86Meta?.path ?? "users",
    meta: usersPJtdsZ5t86Meta || {},
    alias: usersPJtdsZ5t86Meta?.alias || [],
    redirect: usersPJtdsZ5t86Meta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/account/users.vue").then(m => m.default || m)
  }
]
  },
  {
    name: admin_45analyticshPzwEB2EhxMeta?.name ?? "admin-analytics",
    path: admin_45analyticshPzwEB2EhxMeta?.path ?? "/admin-analytics",
    meta: admin_45analyticshPzwEB2EhxMeta || {},
    alias: admin_45analyticshPzwEB2EhxMeta?.alias || [],
    redirect: admin_45analyticshPzwEB2EhxMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/admin-analytics.vue").then(m => m.default || m)
  },
  {
    name: _91id_93rCAHjsUk9FMeta?.name ?? "admin-organizations-id",
    path: _91id_93rCAHjsUk9FMeta?.path ?? "/admin-organizations/:id()",
    meta: _91id_93rCAHjsUk9FMeta || {},
    alias: _91id_93rCAHjsUk9FMeta?.alias || [],
    redirect: _91id_93rCAHjsUk9FMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/admin-organizations/[id].vue").then(m => m.default || m)
  },
  {
    name: indexyFSvNMmUsqMeta?.name ?? "admin-organizations",
    path: indexyFSvNMmUsqMeta?.path ?? "/admin-organizations",
    meta: indexyFSvNMmUsqMeta || {},
    alias: indexyFSvNMmUsqMeta?.alias || [],
    redirect: indexyFSvNMmUsqMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/admin-organizations/index.vue").then(m => m.default || m)
  },
  {
    name: admin_45overviewEvSzAdovgRMeta?.name ?? "admin-overview",
    path: admin_45overviewEvSzAdovgRMeta?.path ?? "/admin-overview",
    meta: admin_45overviewEvSzAdovgRMeta || {},
    alias: admin_45overviewEvSzAdovgRMeta?.alias || [],
    redirect: admin_45overviewEvSzAdovgRMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/admin-overview.vue").then(m => m.default || m)
  },
  {
    name: admin_45panelwZWou2UvyOMeta?.name ?? "admin-panel",
    path: admin_45panelwZWou2UvyOMeta?.path ?? "/admin-panel",
    meta: admin_45panelwZWou2UvyOMeta || {},
    alias: admin_45panelwZWou2UvyOMeta?.alias || [],
    redirect: admin_45panelwZWou2UvyOMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/admin-panel.vue").then(m => m.default || m)
  },
  {
    name: admin_45tariffsZa0k06w9PFMeta?.name ?? "admin-tariffs",
    path: admin_45tariffsZa0k06w9PFMeta?.path ?? "/admin-tariffs",
    meta: admin_45tariffsZa0k06w9PFMeta || {},
    alias: admin_45tariffsZa0k06w9PFMeta?.alias || [],
    redirect: admin_45tariffsZa0k06w9PFMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/admin-tariffs.vue").then(m => m.default || m)
  },
  {
    name: all_45usersB3TaOBFQ8jMeta?.name ?? "all-users",
    path: all_45usersB3TaOBFQ8jMeta?.path ?? "/all-users",
    meta: all_45usersB3TaOBFQ8jMeta || {},
    alias: all_45usersB3TaOBFQ8jMeta?.alias || [],
    redirect: all_45usersB3TaOBFQ8jMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/all-users.vue").then(m => m.default || m)
  },
  {
    name: payment_45result0IPvgacIgYMeta?.name ?? "billing-payment-result",
    path: payment_45result0IPvgacIgYMeta?.path ?? "/billing/payment-result",
    meta: payment_45result0IPvgacIgYMeta || {},
    alias: payment_45result0IPvgacIgYMeta?.alias || [],
    redirect: payment_45result0IPvgacIgYMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/billing/payment-result.vue").then(m => m.default || m)
  },
  {
    name: chestny_45znakl1MH0Q7KS9Meta?.name ?? "chestny-znak",
    path: chestny_45znakl1MH0Q7KS9Meta?.path ?? "/chestny-znak",
    meta: chestny_45znakl1MH0Q7KS9Meta || {},
    alias: chestny_45znakl1MH0Q7KS9Meta?.alias || [],
    redirect: chestny_45znakl1MH0Q7KS9Meta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/chestny-znak.vue").then(m => m.default || m)
  },
  {
    name: _91id_93BNygKPhzNVMeta?.name ?? "client-details-id",
    path: _91id_93BNygKPhzNVMeta?.path ?? "/client/details/:id()",
    meta: _91id_93BNygKPhzNVMeta || {},
    alias: _91id_93BNygKPhzNVMeta?.alias || [],
    redirect: _91id_93BNygKPhzNVMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/client/details/[id].vue").then(m => m.default || m)
  },
  {
    name: indexUderSExJaLMeta?.name ?? "client-list",
    path: indexUderSExJaLMeta?.path ?? "/client/list",
    meta: indexUderSExJaLMeta || {},
    alias: indexUderSExJaLMeta?.alias || [],
    redirect: indexUderSExJaLMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/client/list/index.vue").then(m => m.default || m)
  },
  {
    name: indexUqXYcLvO2aMeta?.name ?? "counterparties",
    path: indexUqXYcLvO2aMeta?.path ?? "/counterparties",
    meta: indexUqXYcLvO2aMeta || {},
    alias: indexUqXYcLvO2aMeta?.alias || [],
    redirect: indexUqXYcLvO2aMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/counterparties/index.vue").then(m => m.default || m)
  },
  {
    name: designerVJeYRcZCNfMeta?.name ?? "designer",
    path: designerVJeYRcZCNfMeta?.path ?? "/designer",
    meta: designerVJeYRcZCNfMeta || {},
    alias: designerVJeYRcZCNfMeta?.alias || [],
    redirect: designerVJeYRcZCNfMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/designer.vue").then(m => m.default || m)
  },
  {
    name: index5GWPvAs6IDMeta?.name ?? "document-list",
    path: index5GWPvAs6IDMeta?.path ?? "/document/list",
    meta: index5GWPvAs6IDMeta || {},
    alias: index5GWPvAs6IDMeta?.alias || [],
    redirect: index5GWPvAs6IDMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/document/list/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_934NjLRjKhcAMeta?.name ?? "documents-slug",
    path: _91slug_934NjLRjKhcAMeta?.path ?? "/documents/:slug()",
    meta: _91slug_934NjLRjKhcAMeta || {},
    alias: _91slug_934NjLRjKhcAMeta?.alias || [],
    redirect: _91slug_934NjLRjKhcAMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/documents/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexsLOVaL63cvMeta?.name ?? "element-catalog",
    path: indexsLOVaL63cvMeta?.path ?? "/element-catalog",
    meta: indexsLOVaL63cvMeta || {},
    alias: indexsLOVaL63cvMeta?.alias || [],
    redirect: indexsLOVaL63cvMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/element-catalog/index.vue").then(m => m.default || m)
  },
  {
    name: indexqHtEbes263Meta?.name ?? "fbs-assembly",
    path: indexqHtEbes263Meta?.path ?? "/fbs/assembly",
    meta: indexqHtEbes263Meta || {},
    alias: indexqHtEbes263Meta?.alias || [],
    redirect: indexqHtEbes263Meta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/fbs/assembly/index.vue").then(m => m.default || m)
  },
  {
    name: supplies9o9GslF2CGMeta?.name ?? "fbs-assembly-supplies",
    path: supplies9o9GslF2CGMeta?.path ?? "/fbs/assembly/supplies",
    meta: supplies9o9GslF2CGMeta || {},
    alias: supplies9o9GslF2CGMeta?.alias || [],
    redirect: supplies9o9GslF2CGMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/fbs/assembly/supplies.vue").then(m => m.default || m)
  },
  {
    name: indexAyQ4jpnHekMeta?.name ?? "fbs-supplies",
    path: indexAyQ4jpnHekMeta?.path ?? "/fbs",
    meta: indexAyQ4jpnHekMeta || {},
    alias: indexAyQ4jpnHekMeta?.alias || [],
    redirect: indexAyQ4jpnHekMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/fbs/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93kIMXtOSI25Meta?.name ?? "fbs-supply-detail",
    path: _91id_93kIMXtOSI25Meta?.path ?? "/fbs/supplies/:id()",
    meta: _91id_93kIMXtOSI25Meta || {},
    alias: _91id_93kIMXtOSI25Meta?.alias || [],
    redirect: _91id_93kIMXtOSI25Meta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/fbs/supplies/[id].vue").then(m => m.default || m)
  },
  {
    name: indexgUxLAkdHDzMeta?.name ?? "fbs-verification",
    path: indexgUxLAkdHDzMeta?.path ?? "/fbs/verification",
    meta: indexgUxLAkdHDzMeta || {},
    alias: indexgUxLAkdHDzMeta?.alias || [],
    redirect: indexgUxLAkdHDzMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/fbs/verification/index.vue").then(m => m.default || m)
  },
  {
    name: feature_45lockednYFwxf0OENMeta?.name ?? "feature-locked",
    path: feature_45lockednYFwxf0OENMeta?.path ?? "/feature-locked",
    meta: feature_45lockednYFwxf0OENMeta || {},
    alias: feature_45lockednYFwxf0OENMeta?.alias || [],
    redirect: feature_45lockednYFwxf0OENMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/feature-locked.vue").then(m => m.default || m)
  },
  {
    name: indexaLy3W3JfhNMeta?.name ?? "index",
    path: indexaLy3W3JfhNMeta?.path ?? "/",
    meta: indexaLy3W3JfhNMeta || {},
    alias: indexaLy3W3JfhNMeta?.alias || [],
    redirect: indexaLy3W3JfhNMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/index.vue").then(m => m.default || m)
  },
  {
    name: inviteAH0ZX8KVUSMeta?.name ?? "invite",
    path: inviteAH0ZX8KVUSMeta?.path ?? "/invite",
    meta: inviteAH0ZX8KVUSMeta || {},
    alias: inviteAH0ZX8KVUSMeta?.alias || [],
    redirect: inviteAH0ZX8KVUSMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/invite.vue").then(m => m.default || m)
  },
  {
    name: _91key_93wY3A1hYFi9Meta?.name ?? "legal-key",
    path: _91key_93wY3A1hYFi9Meta?.path ?? "/legal/:key()",
    meta: _91key_93wY3A1hYFi9Meta || {},
    alias: _91key_93wY3A1hYFi9Meta?.alias || [],
    redirect: _91key_93wY3A1hYFi9Meta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/legal/[key].vue").then(m => m.default || m)
  },
  {
    name: indexeUJ4xh0kfVMeta?.name ?? "legal",
    path: indexeUJ4xh0kfVMeta?.path ?? "/legal",
    meta: indexeUJ4xh0kfVMeta || {},
    alias: indexeUJ4xh0kfVMeta?.alias || [],
    redirect: indexeUJ4xh0kfVMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/legal/index.vue").then(m => m.default || m)
  },
  {
    name: logintWMHmBLVXhMeta?.name ?? "login",
    path: logintWMHmBLVXhMeta?.path ?? "/login",
    meta: logintWMHmBLVXhMeta || {},
    alias: logintWMHmBLVXhMeta?.alias || [],
    redirect: logintWMHmBLVXhMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/login.vue").then(m => m.default || m)
  },
  {
    name: labelsq9aQmQDivpMeta?.name ?? "marking-labels",
    path: labelsq9aQmQDivpMeta?.path ?? "/marking/labels",
    meta: labelsq9aQmQDivpMeta || {},
    alias: labelsq9aQmQDivpMeta?.alias || [],
    redirect: labelsq9aQmQDivpMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/marking/labels.vue").then(m => m.default || m)
  },
  {
    name: offerh1BW0Pvc1HMeta?.name ?? "offer",
    path: offerh1BW0Pvc1HMeta?.path ?? "/offer",
    meta: offerh1BW0Pvc1HMeta || {},
    alias: offerh1BW0Pvc1HMeta?.alias || [],
    redirect: offerh1BW0Pvc1HMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/offer.vue").then(m => m.default || m)
  },
  {
    name: personalVm9CvgOFmQMeta?.name ?? "personal",
    path: personalVm9CvgOFmQMeta?.path ?? "/personal",
    meta: personalVm9CvgOFmQMeta || {},
    alias: personalVm9CvgOFmQMeta?.alias || [],
    redirect: personalVm9CvgOFmQMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/personal.vue").then(m => m.default || m)
  },
  {
    name: indexK3GLGppqVAMeta?.name ?? "label-groups",
    path: indexK3GLGppqVAMeta?.path ?? "/printing/groups",
    meta: indexK3GLGppqVAMeta || {},
    alias: indexK3GLGppqVAMeta?.alias || [],
    redirect: indexK3GLGppqVAMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/printing/groups/index.vue").then(m => m.default || m)
  },
  {
    name: indexwQZZyN1PLHMeta?.name ?? "print-jobs",
    path: indexwQZZyN1PLHMeta?.path ?? "/printing/jobs",
    meta: indexwQZZyN1PLHMeta || {},
    alias: indexwQZZyN1PLHMeta?.alias || [],
    redirect: indexwQZZyN1PLHMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/printing/jobs/index.vue").then(m => m.default || m)
  },
  {
    name: indexzWoxo0Q9ZgMeta?.name ?? "printer",
    path: indexzWoxo0Q9ZgMeta?.path ?? "/printing/printer",
    meta: indexzWoxo0Q9ZgMeta || {},
    alias: indexzWoxo0Q9ZgMeta?.alias || [],
    redirect: indexzWoxo0Q9ZgMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/printing/printer/index.vue").then(m => m.default || m)
  },
  {
    name: indexV2aUNBKdoCMeta?.name ?? "sessions",
    path: indexV2aUNBKdoCMeta?.path ?? "/printing/sessions",
    meta: indexV2aUNBKdoCMeta || {},
    alias: indexV2aUNBKdoCMeta?.alias || [],
    redirect: indexV2aUNBKdoCMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/printing/sessions/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93YctRdDDWgbMeta?.name ?? "product-details-id",
    path: _91id_93YctRdDDWgbMeta?.path ?? "/product/details/:id()",
    meta: _91id_93YctRdDDWgbMeta || {},
    alias: _91id_93YctRdDDWgbMeta?.alias || [],
    redirect: _91id_93YctRdDDWgbMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/product/details/[id].vue").then(m => m.default || m)
  },
  {
    name: indexXzaJOqSPAFMeta?.name ?? "product-list",
    path: indexXzaJOqSPAFMeta?.path ?? "/product/list",
    meta: indexXzaJOqSPAFMeta || {},
    alias: indexXzaJOqSPAFMeta?.alias || [],
    redirect: indexXzaJOqSPAFMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/product/list/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93Mvbro1fQKVMeta?.name ?? "product-marking-id",
    path: _91id_93Mvbro1fQKVMeta?.path ?? "/product/marking/:id()",
    meta: _91id_93Mvbro1fQKVMeta || {},
    alias: _91id_93Mvbro1fQKVMeta?.alias || [],
    redirect: _91id_93Mvbro1fQKVMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/product/marking/[id].vue").then(m => m.default || m)
  },
  {
    name: labelsEsxizUJ20hMeta?.name ?? "product-marking-labels",
    path: labelsEsxizUJ20hMeta?.path ?? "/product/marking/labels",
    meta: labelsEsxizUJ20hMeta || {},
    alias: labelsEsxizUJ20hMeta?.alias || [],
    redirect: labelsEsxizUJ20hMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/product/marking/labels.vue").then(m => m.default || m)
  },
  {
    name: _91id_93YnfinMMOW3Meta?.name ?? "production-order-details-id",
    path: _91id_93YnfinMMOW3Meta?.path ?? "/production-order/details/:id()",
    meta: _91id_93YnfinMMOW3Meta || {},
    alias: _91id_93YnfinMMOW3Meta?.alias || [],
    redirect: _91id_93YnfinMMOW3Meta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/production-order/details/[id].vue").then(m => m.default || m)
  },
  {
    name: guide76ctu0BL8MMeta?.name ?? "production-order-guide",
    path: guide76ctu0BL8MMeta?.path ?? "/production-order/guide",
    meta: guide76ctu0BL8MMeta || {},
    alias: guide76ctu0BL8MMeta?.alias || [],
    redirect: guide76ctu0BL8MMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/production-order/guide.vue").then(m => m.default || m)
  },
  {
    name: indextEqHIxIomhMeta?.name ?? "production-order-list",
    path: indextEqHIxIomhMeta?.path ?? "/production-order/list",
    meta: indextEqHIxIomhMeta || {},
    alias: indextEqHIxIomhMeta?.alias || [],
    redirect: indextEqHIxIomhMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/production-order/list/index.vue").then(m => m.default || m)
  },
  {
    name: registerEludZrAJ7mMeta?.name ?? "register",
    path: registerEludZrAJ7mMeta?.path ?? "/register",
    meta: registerEludZrAJ7mMeta || {},
    alias: registerEludZrAJ7mMeta?.alias || [],
    redirect: registerEludZrAJ7mMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/register.vue").then(m => m.default || m)
  },
  {
    name: _91id_93wEayt8uuJBMeta?.name ?? "repricer-details-id",
    path: _91id_93wEayt8uuJBMeta?.path ?? "/repricer/details/:id()",
    meta: _91id_93wEayt8uuJBMeta || {},
    alias: _91id_93wEayt8uuJBMeta?.alias || [],
    redirect: _91id_93wEayt8uuJBMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/repricer/details/[id].vue").then(m => m.default || m)
  },
  {
    name: index1cWBlJtDpMMeta?.name ?? "repricer-list",
    path: index1cWBlJtDpMMeta?.path ?? "/repricer/list",
    meta: index1cWBlJtDpMMeta || {},
    alias: index1cWBlJtDpMMeta?.alias || [],
    redirect: index1cWBlJtDpMMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/repricer/list/index.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordpQOmNanLiBMeta?.name ?? "reset-password",
    path: reset_45passwordpQOmNanLiBMeta?.path ?? "/reset-password",
    meta: reset_45passwordpQOmNanLiBMeta || {},
    alias: reset_45passwordpQOmNanLiBMeta?.alias || [],
    redirect: reset_45passwordpQOmNanLiBMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: _91id_93Bl1uSOXBbqMeta?.name ?? "scenario-detail",
    path: _91id_93Bl1uSOXBbqMeta?.path ?? "/scenarios/:id()",
    meta: _91id_93Bl1uSOXBbqMeta || {},
    alias: _91id_93Bl1uSOXBbqMeta?.alias || [],
    redirect: _91id_93Bl1uSOXBbqMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/scenarios/[id].vue").then(m => m.default || m)
  },
  {
    name: index10Ko9QvYrWMeta?.name ?? "scenarios",
    path: index10Ko9QvYrWMeta?.path ?? "/scenarios",
    meta: index10Ko9QvYrWMeta || {},
    alias: index10Ko9QvYrWMeta?.alias || [],
    redirect: index10Ko9QvYrWMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/scenarios/index.vue").then(m => m.default || m)
  },
  {
    name: shopsP4s69TuimfMeta?.name ?? "shops",
    path: shopsP4s69TuimfMeta?.path ?? "/shops",
    meta: shopsP4s69TuimfMeta || {},
    alias: shopsP4s69TuimfMeta?.alias || [],
    redirect: shopsP4s69TuimfMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/shops.vue").then(m => m.default || m)
  },
  {
    name: subscriptione9L32hkxLsMeta?.name ?? "subscription",
    path: subscriptione9L32hkxLsMeta?.path ?? "/subscription",
    meta: subscriptione9L32hkxLsMeta || {},
    alias: subscriptione9L32hkxLsMeta?.alias || [],
    redirect: subscriptione9L32hkxLsMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/subscription.vue").then(m => m.default || m)
  },
  {
    name: indexAlao6tTthjMeta?.name ?? "support-admin",
    path: indexAlao6tTthjMeta?.path ?? "/support-admin",
    meta: indexAlao6tTthjMeta || {},
    alias: indexAlao6tTthjMeta?.alias || [],
    redirect: indexAlao6tTthjMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/support-admin/index.vue").then(m => m.default || m)
  },
  {
    name: indexzcOq6bApn1Meta?.name ?? "support",
    path: indexzcOq6bApn1Meta?.path ?? "/support",
    meta: indexzcOq6bApn1Meta || {},
    alias: indexzcOq6bApn1Meta?.alias || [],
    redirect: indexzcOq6bApn1Meta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/support/index.vue").then(m => m.default || m)
  },
  {
    name: indexYbplYOyJstMeta?.name ?? "system-employees",
    path: indexYbplYOyJstMeta?.path ?? "/system-employees",
    meta: indexYbplYOyJstMeta || {},
    alias: indexYbplYOyJstMeta?.alias || [],
    redirect: indexYbplYOyJstMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/system-employees/index.vue").then(m => m.default || m)
  },
  {
    name: verify_45emailTB4QNELewGMeta?.name ?? "verify-email",
    path: verify_45emailTB4QNELewGMeta?.path ?? "/verify-email",
    meta: verify_45emailTB4QNELewGMeta || {},
    alias: verify_45emailTB4QNELewGMeta?.alias || [],
    redirect: verify_45emailTB4QNELewGMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/verify-email.vue").then(m => m.default || m)
  },
  {
    name: indexKz5ot380pFMeta?.name ?? "warehouse-cells",
    path: indexKz5ot380pFMeta?.path ?? "/warehouse/cells",
    meta: indexKz5ot380pFMeta || {},
    alias: indexKz5ot380pFMeta?.alias || [],
    redirect: indexKz5ot380pFMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/warehouse/cells/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93XShcRrf8PtMeta?.name ?? "warehouse-intake-id",
    path: _91id_93XShcRrf8PtMeta?.path ?? "/warehouse/intake/:id()",
    meta: _91id_93XShcRrf8PtMeta || {},
    alias: _91id_93XShcRrf8PtMeta?.alias || [],
    redirect: _91id_93XShcRrf8PtMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/warehouse/intake/[id].vue").then(m => m.default || m)
  },
  {
    name: indexqZrFIWxTSuMeta?.name ?? "warehouse-intake",
    path: indexqZrFIWxTSuMeta?.path ?? "/warehouse/intake",
    meta: indexqZrFIWxTSuMeta || {},
    alias: indexqZrFIWxTSuMeta?.alias || [],
    redirect: indexqZrFIWxTSuMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/warehouse/intake/index.vue").then(m => m.default || m)
  },
  {
    name: indexyizSDLvUlYMeta?.name ?? "warehouse-journal",
    path: indexyizSDLvUlYMeta?.path ?? "/warehouse/journal",
    meta: indexyizSDLvUlYMeta || {},
    alias: indexyizSDLvUlYMeta?.alias || [],
    redirect: indexyizSDLvUlYMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/warehouse/journal/index.vue").then(m => m.default || m)
  },
  {
    name: indexx8tPisRqaAMeta?.name ?? "warehouse-settings",
    path: indexx8tPisRqaAMeta?.path ?? "/warehouse/settings",
    meta: indexx8tPisRqaAMeta || {},
    alias: indexx8tPisRqaAMeta?.alias || [],
    redirect: indexx8tPisRqaAMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/warehouse/settings/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93A3GwYtz5wQMeta?.name ?? "warehouse-staff-id",
    path: _91id_93A3GwYtz5wQMeta?.path ?? "/warehouse/staff/:id()",
    meta: _91id_93A3GwYtz5wQMeta || {},
    alias: _91id_93A3GwYtz5wQMeta?.alias || [],
    redirect: _91id_93A3GwYtz5wQMeta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/warehouse/staff/[id].vue").then(m => m.default || m)
  },
  {
    name: indexXB5MxDUuY0Meta?.name ?? "warehouse-staff",
    path: indexXB5MxDUuY0Meta?.path ?? "/warehouse/staff",
    meta: indexXB5MxDUuY0Meta || {},
    alias: indexXB5MxDUuY0Meta?.alias || [],
    redirect: indexXB5MxDUuY0Meta?.redirect,
    component: () => import("/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/pages/warehouse/staff/index.vue").then(m => m.default || m)
  }
]